import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { JointBillContext } from "@features/JointBillList/utils";
import { JointBillStatusBadge } from "@features/JointBillStatusBadge/JointBillStatusBadge";
import { Button } from "@components/Button";
import { type PeriodState } from "@services/overview/types";

interface IJointBillHeaderStatusCellProps {
  periodState: PeriodState;
  isOpenPeriodButtonEnabled?: boolean;
  onOpenPeriodButtonClick?: () => void;
}

export const JointBillHeaderStatusCell: React.FC<
  IJointBillHeaderStatusCellProps
> = ({ periodState, isOpenPeriodButtonEnabled, onOpenPeriodButtonClick }) => {
  const { t } = useTranslation();
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="flex flex-col justify-center gap-2">
      {!(!isSummaryMode && isOpenPeriodButtonEnabled) && (
        <JointBillStatusBadge periodState={periodState} />
      )}
      {!isSummaryMode && isOpenPeriodButtonEnabled && (
        <Button variant="secondary" onClick={onOpenPeriodButtonClick}>
          {t("bill.interactions.openPeriod.label")}
        </Button>
      )}
    </div>
  );
};
